"use strict";

exports.__esModule = true;
exports.ScatterPlotThumbnail = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Thumbnail for MetricChartWidget.
 */
var ScatterPlotThumbnail = exports.ScatterPlotThumbnail = function ScatterPlotThumbnail(props) {
  var _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    width = props.width,
    height = props.height;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: width,
    height: height,
    x: x,
    y: y
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: x,
    y: y,
    width: width,
    height: height,
    fill: "#ffffff"
  }), generateCircles(Object.assign({}, props, {
    x: x,
    y: y
  })));
};
var generateCircles = function generateCircles(_ref) {
  var x = _ref.x,
    y = _ref.y,
    width = _ref.width,
    height = _ref.height,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "#9467bd" : _ref$color,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? 7 : _ref$radius;
  var currentX = x + 2;
  var totalPoints = Math.ceil((width - 4) / (radius + 15));
  var circles = [];
  for (var i = 0; i < totalPoints; i++) {
    var barHeight = (height - 4) * Math.random();
    var currentY = y + height - barHeight;
    circles.push(/*#__PURE__*/_react["default"].createElement("circle", {
      key: String(i),
      className: "scatter-plot-thumbnail-point",
      cx: currentX,
      cy: currentY,
      r: radius,
      fill: color
    }));
    currentX += radius + 15;
  }
  return circles;
};